/* Bella Tu — card loader
 *
 * window.BTCard fetches a product's card from the storefront
 * (/products/<handle>?view=card or ?view=card-row) and hands back the element,
 * so a card built after the page loads is the theme's own product-card snippet.
 * recently-viewed.js is its caller. It lived in wishlist.js until the theme's
 * wishlist was removed (2026-10-10); nothing here knows about saves.
 */

/* i18n bridge, from snippets/i18n-js.liquid. Redefining it here when it is
   absent keeps every call site working in English rather than throwing. */
window.BT_T = window.BT_T || function (key, fallback) { return fallback; };

(function () {
  /* Cards are the theme's own product-card snippet, rendered by Shopify
     through templates/product.card.liquid (/products/<handle>?view=card),
     read by recently-viewed.js as window.BTCard.

     They were built here as a JavaScript string until 2026-10-01, a second
     card that had drifted from the first: studio photo where the grid shows
     the location shot, no sale price, no sold-out or pre-order badge, no
     colour override, one 600px image (Codex review). One snippet is one card.

     load() reports each handle's outcome rather than collapsing them: `gone`
     only for a 404, which is a product deleted or unpublished since it was
     saved; `failed` for anything else -- offline, throttled, a server error --
     which says nothing about the product. Treating those alike is how a bad
     connection used to empty a shopper's wishlist for good. */
  // view: 'card' for a grid, 'card-row' for a row that is a carousel on a
  // phone (recently viewed). Same snippet; the two templates differ only in
  // the image sizes hint they pass it.
  function cardUrl(handle, view) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root + 'products/' + encodeURIComponent(handle) + '?view=' + (view || 'card');
  }

  /* A response is a card only if it is exactly one element, a .product-card,
     carrying the handle asked for (or the one Shopify redirected to, when a
     product has been renamed). Anything else -- a full page, a password or
     challenge page served 200, an error page, a card for another product --
     is a failed load, and the save is kept. A substring test for
     "product-card" used to let a whole page through whenever its stylesheet
     mentioned the class (Codex, second pass, 2026-10-01).

     The element is returned rather than its HTML, and nothing else from the
     response is ever inserted. Inside a <template> its images are inert, so
     the host's sizes hint can be set before anything is fetched. */
  // The handle a redirect landed on, if it landed on this storefront's own
  // product route; anything else is no handle at all.
  function servedHandle(url) {
    try {
      var u = new URL(url, window.location.href);
      if (u.origin !== window.location.origin) return '';
      var path = u.pathname;
      var i = path.indexOf('/products/');
      return i === -1 ? '' : decodeURIComponent(path.slice(i + 10).split('/')[0]);
    } catch (e) { return ''; }
  }

  function cardFrom(html, handle, url, sizes) {
    var t = document.createElement('template');
    t.innerHTML = html;
    var roots = Array.prototype.filter.call(t.content.childNodes, function (n) {
      return n.nodeType === 1 || (n.nodeType === 3 && n.textContent.trim() !== '');
    });
    if (roots.length !== 1 || roots[0].nodeType !== 1) return null;
    var el = roots[0];
    if (!el.matches('.product-card[data-card-handle]')) return null;
    var got = el.getAttribute('data-card-handle');
    if (got !== handle && got !== servedHandle(url)) return null;
    if (sizes) {
      Array.prototype.forEach.call(el.querySelectorAll('img[sizes]'), function (img) {
        img.setAttribute('sizes', sizes);
      });
    }
    return el;
  }

  // sizes: the host's own image hint (data-card-sizes, from card-sizes.liquid),
  // which knows its column setting where the ?view=card template cannot.
  function load(handles, view, sizes) {
    return Promise.all(handles.map(function (h) {
      return fetch(cardUrl(h, view))
        .then(function (r) {
          if (r.status === 404) return { handle: h, gone: true };
          if (!r.ok) return { handle: h, failed: true };
          return r.text().then(function (html) {
            var el = cardFrom(html, h, r.url, sizes);
            // canonical: the handle the product has now, which differs from
            // the saved one when it was renamed and the old URL redirected.
            return el ? { handle: h, el: el, canonical: el.getAttribute('data-card-handle') } : { handle: h, failed: true };
          });
        })
        .catch(function () { return { handle: h, failed: true }; });
    }));
  }

  window.BTCard = { load: load };
})();
